<template>

    <label v-if="labelText" :class="{ required: required }" class="form-control-label">{{ labelText }}</label>
    <input v-if="(!addOnIcon || addOnIcon == '') && (!addOnText || addOnText == '')" :type="type" autocomplete="off"
        class="form-control" :class="class" :value="modelValue"
        v-on="(justNumber || justDecimalNumber) ? { keypress: isNumberKey } : {}" :disabled="disabled"
        @input="$emit('update:modelValue', $event.target.value)" />

    <div v-else class="input-group">
        <input :type="type" autocomplete="off" class="form-control" :class="class" :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            v-on="(justNumber || justDecimalNumber) ? { keypress: isNumberKey } : {}" :disabled="disabled" />
        <div class="input-group-append">
            <span v-if="(!addOnIcon || addOnIcon == '')">
                <fa-icon :icon="'fas ' + addOnIcon"></fa-icon>
            </span>
            <span v-else>{{ addOnText }}</span>
        </div>
    </div>

</template>

<script>
export default {
    name: "textInput",
    inheritAttrs: false,
    props: {
        modelValue: '',
        justNumber: {
            type: Boolean,
            default: false
        },
        justDecimalNumber: {
            type: Boolean,
            default: false
        },
        labelText: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: 'text'
        },
        class: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        addOnIcon: {
            type: String,
            default: ''
        },
        addOnText: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
        }
    },
    computed: {

        getClass() {
            if (this.justNumber == true || this.justDecimalNumber == true)
                return this.class + " text-start dir-ltr";
            else
                return this.class;
        }

    },
    watch:
    {
        modelValue: {
            handler: function (newValue, oldValue) {
                this.$emit('update:modelValue', newValue);
            },
            deep: true
        }
    },
    methods:
    {
        isNumberKey(evt) {

            let obj = evt.currentTarget;
            let allowDecimal = this.justDecimalNumber || false;
            var charCode = (evt.which) ? evt.which : evt.keyCode
            var value = obj.value;
            var dotcontains = true;
            if (allowDecimal)
                dotcontains = value.indexOf(".") != -1;

            //is dot key
            if (charCode == 46) {
                if (dotcontains)
                    evt.preventDefault();
                else { } //return true;
            }
            else if (charCode > 31 && (charCode < 48 || charCode > 57))
                evt.preventDefault()
            //return true;
        }
    },
    mounted() {
    }

};
</script>
